// extracted by mini-css-extract-plugin
export default {"video":"BackgroundVideo_video__inZj7"};